import {
  LayoutDashboard, Server, Box, Network, HardDrive, Archive, Activity, ScrollText, ListChecks,
  Globe, LayoutTemplate, Rocket, GitBranch, Database, Mail, Waypoints, Cloud,
  Users, FolderKanban, UserCog, KeyRound, Settings, LifeBuoy, MessageSquare, ClipboardList,
} from "lucide-react";

// Estrutura de navegação da TintiCloud (agrupada).
export const NAV_GROUPS = [
  {
    label: "Principal",
    items: [{ to: "/", label: "Dashboard", icon: LayoutDashboard, end: true }],
  },
  {
    label: "Infraestrutura",
    items: [
      { to: "/servidores", label: "Servidores", icon: Server },
      { to: "/containers", label: "Containers", icon: Box },
      { to: "/redes", label: "Redes", icon: Network },
      { to: "/volumes", label: "Volumes", icon: HardDrive },
      { to: "/backups", label: "Backups", icon: Archive },
      { to: "/monitoramento", label: "Monitoramento", icon: Activity },
      { to: "/logs", label: "Logs", icon: ScrollText },
      { to: "/jobs", label: "Jobs", icon: ListChecks },
    ],
  },
  {
    label: "Aplicações",
    items: [
      { to: "/dominios", label: "Sites & Domínios", icon: Globe },
      { to: "/wordpress", label: "WordPress", icon: LayoutTemplate },
      { to: "/deployments", label: "Deployments", icon: Rocket },
      { to: "/git", label: "Git Repositories", icon: GitBranch },
      { to: "/bancos", label: "Banco de Dados", icon: Database },
      { to: "/email", label: "E-mail", icon: Mail },
    ],
  },
  {
    label: "Ferramentas",
    items: [
      { to: "/npm", label: "Nginx Proxy Manager", icon: Waypoints },
      { to: "/cloudflare", label: "Cloudflare", icon: Cloud },
    ],
  },
  {
    label: "Organização",
    items: [
      { to: "/clientes", label: "Clientes", icon: Users },
      { to: "/portal", label: "Portal do Cliente", icon: LifeBuoy },
      { to: "/chamados", label: "Suporte", icon: MessageSquare },
      { to: "/projetos", label: "Projetos", icon: FolderKanban },
      { to: "/inventario", label: "Inventário", icon: ClipboardList },
      { to: "/usuarios", label: "Usuários", icon: UserCog },
      { to: "/vault", label: "Vault & Secrets", icon: KeyRound },
      { to: "/configuracoes", label: "Configurações", icon: Settings },
    ],
  },
];

export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);
